import Layout from './components/Layout/Layout';
// import SideDrawer from './components/Layout/SideDrawer';
import SweaterPage from './Containers/SweaterPage';

function App() {
	return (
		<div>
			<Layout>
				<SweaterPage />
			</Layout>
		</div>
	);
}

export default App;
